import { styled } from '@mui/material/styles'

const IMG_WIDTH = '7rem'

export const StyledImg = styled('img')(() => ({
  width: IMG_WIDTH,
  borderRadius: '8px%',
}))
